import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const preExportRouter: Array<RouteRecordRaw> = [
    {
        path: '/pre-export',
        name: '数据预导出',
        component: Layout,
        meta: { title: '数据预导出', icon: 'icon-export', alwaysShow: true },
        children: [
            {
                path: 'finance',
                name: '财务数据',
                component: () => import('@/views/pre-export/Index.vue'),
                meta: { title: '财务数据' }
            },
            {
                path: 'operation',
                name: '运营数据',
                component: () => import('@/views/pre-export/Index.vue'),
                meta: { title: '运营数据' }
            },
            {
                path: 'business',
                name: '商务数据',
                component: () => import('@/views/pre-export/Index.vue'),
                meta: { title: '商务数据' }
            },
            {
                path: 'service',
                name: '客服数据',
                component: () => import('@/views/pre-export/Index.vue'),
                meta: { title: '客服数据' }
            },
            {
                path: 'common',
                name: '综合数据',
                component: () => import('@/views/pre-export/Index.vue'),
                meta: { title: '综合数据' }
            },
            {
                path: 'image_data',
                name: '图片数据',
                component: () => import('@/views/pre-export/ImageData.vue'),
                meta: { title: '图片数据' }
            },
            {
                path: 'image_data_apply',
                name: '图片下载申请',
                component: () => import('@/views/pre-export/ImageDataApply.vue'),
                meta: { title: '图片下载申请' }
            },
            {
                path: 'price-list',
                name: '报价单列表',
                component: () => import('@/views/pre-export/PriceList.vue'),
                meta: { title: '报价单列表' }
            },
        ]
    }
]

export default preExportRouter